import { sha1 } from './crypto';

/**
 * Check if a password has been exposed in known data breaches
 * Uses the HaveIBeenPwned API with k-Anonymity model
 * @param password - The password to check
 * @returns true if the password is compromised, false otherwise
 */
export async function checkPasswordBreached(password: string): Promise<{ breached: boolean; count?: number }> {
  try {
    // Hash the password with SHA-1
    const hash = await sha1(password);
    const prefix = hash.substring(0, 5).toUpperCase();
    const suffix = hash.substring(5).toUpperCase();
    
    // Query the HaveIBeenPwned API with k-Anonymity
    const response = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`, {
      headers: {
        'Add-Padding': 'true', // Request padding for privacy
      },
    });
    
    if (!response.ok) {
      console.error('HaveIBeenPwned API error:', response.status);
      return { breached: false }; // Fail open - don't block user if API is down
    }
    
    const text = await response.text();
    const lines = text.split('\r\n');
    
    for (const line of lines) {
      const [hashSuffix, countStr] = line.split(':');
      if (hashSuffix === suffix) {
        const count = parseInt(countStr, 10);
        return { breached: true, count };
      }
    }
    
    return { breached: false };
  } catch (error) {
    console.error('Error checking password breach:', error);
    return { breached: false }; // Fail open
  }
}
